import styled, { css, createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

import BButton from 'ui/blocks/Button'

export const HostStyles = createGlobalStyle`
  :host, :root {
    --minicart-accent-color: var(--color-accent-background, ${color('branding')});
    --minicart-accent-text-color: var(--color-accent-foreground, ${color('white')});
    --minicart-accent-outline: var(--color-outline, ${color('Text/Primary')});
    --minicart-typo-color: var(--color-primary-foreground, ${color('Text/Primary')});
    --minicart-background-color: var(--color-primary-background, ${color('white')});
    --minicart-header-color: var(--color-accent-foreground, ${color('white')});
    --minicart-warning-color: ${color('Danger/Base')};
    /* Use HEX with alpha to get background colour */
    --minicart-warning-background-color: ${color('Danger/Base')}22;
    --minicart-border-radius: var(--border-radius-sm, 8px);
    --minicart-border-color: var(--color-border, ${color('Misc/Divider')});
    --minicart-padding: var(--horizontal-padding, 16px);
    --minicart-image-width: 56px;
    --minicart-z-index: 9999;

    --minicart-font: var(--font-body, Source Sans Pro, sans-serif);
    --minicart-font-size: 14px;
    --minicart-font-weight-normal: 400;
    --minicart-font-weight-bold: 600;
  }
`

export const MiniCart = styled.div`
  position: fixed;

  top: 0;
  right: 0;

  display: none;
  flex-direction: column;

  height: 100%;
  width: 100%;

  min-height: 80vh;
  min-width: 300px;

  background: var(--minicart-background-color);
  color: var(--minicart-typo-color);

  border-radius: var(--minicart-border-radius);
  box-shadow: 0 5px 40px rgba(0,0,0,0.16)!important;

  transition: all 100ms ease-in;

  overflow: hidden;
  overscroll-behavior: none;
  pointer-events: auto;

  font-family: var(--minicart-font);
  font-size: var(--minicart-font-size);

  ${({ open }) => open && css`
    display: flex;
  `}

  ${({ portal }) => portal && css`
    position: relative;
    width: 380px;
    height: 780px;
    max-height: 80vh;
    bottom: 0;
    right: 0;
  `}

  svg {
    height: 1em;
  }

  z-index: var(--minicart-z-index);
`

export const Head = styled.div`
  border-radius: var(--minicart-border-radius) var(--minicart-border-radius) 0 0;
  width: 100%;
  z-index: 1;

  background: var(--minicart-accent-color);
  color: var(--minicart-header-color);

  p {
    margin: 0;
    color: var(--minicart-header-color);
  }

`

export const Close = styled.a`
  cursor: pointer;

  position: absolute;
  right: 0;
  top: 0;

  padding: var(--minicart-padding);
`

export const Title = styled.div`
  position: relative;

  display: flex;
  justify-content: space-between;

  padding: var(--minicart-padding);

  border-top-right-radius: var(--mincart-border-radius);
  border-top-left-radius: var(--mincart-border-radius);

  z-index: 2;
`

export const Lines = styled.div`
  position: relative;

  flex-grow: 1;

  width: 100%;

  overflow-x: hidden;
  overflow-y: auto;

  overscroll-behavior: none;

  z-index: 0;

  & > ul {
    list-style: none;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline: 0;
  }
`

export const Notice = styled.div`
  display: flex;

  align-items: center;

  gap: var(--minicart-padding);

  padding: var(--minicart-padding);
  margin: var(--minicart-padding);
  margin-bottom: 0;

  background: var(--minicart-warning-background-color);
  color: var(--minicart-warning-color);

  font-size: var(--minicart-font-size);

  border-radius: var(--minicart-border-radius);

  ${({ inSummary }) => inSummary && css`
    margin-left: 0;
    margin-right: 0;
    margin-top: 0.8em;
  `}
`

export const Cleanstate = styled.div`
  margin-top: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  text-align: center;


  font-size: 1.1em;
  line-height: 1.6em;

  gap: var(--minicart-padding);

  ${BButton} button {
    background-color: var(--minicart-accent-color) !important;
  }

  svg {
    color: var(--minicart-accent-color);
    fill: var(--minicart-accent-color);
  }
`

export const Summary = styled.div`
  position: relative;

  width: 100%;
  padding: var(--minicart-padding) 0;
  border-top: 1px solid var(--minicart-border-color);

  background: var(--minicart-background-color);

  box-shadow: 0px -4px 12px rgba(33, 59, 71, 0.12);
  box-sizing: border-box;

  z-index: 3;
`

export const Detail = styled.div`
  font-size: var(--minicart-font-size);
  line-height: 1.4em;

  ${({ bold }) => bold && css`
    font-weight: var(--minicart-font-weight-bold);
  `}
`

export const Amount = styled.span`
  float: right;
`

export const PoweredBy = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  padding-top: 16px;

  svg {
    filter: grayscale(100%);

    #icon {
      fill: var(--minicart-typo-color);
    }
  }

  &:hover {
    svg {
      filter: grayscale(0);
    }
  }

  a {
    display: flex;
    align-items: center;

    gap: 12px;

    font-size: 12px;
    color: var(--minicart-typo-color);

    opacity: 0.8;

    text-decoration: none;
    line-height: 20px;

    &:hover, &:active {
      opacity: 1;
    }
  }
`

export const Button = styled.button`
  display: block;
  width: 100%;

  padding: 0.75em;

  border: none;
  border-radius: var(--minicart-border-radius);
  text-align: center;

  font-size: var(--minicart-font-size);
  font-weight: var(--minicart-font-weight-bold);

  text-decoration: none;
  cursor: pointer;

  background: var(--minicart-accent-color);
  color: var(--minicart-accent-text-color);
  border: 1px solid;
  border-color: var(--minicart-accent-color);

  ${({ invert }) => invert && css`
    border-color: var(--minicart-accent-outline);
    color: var(--minicart-accent-outline);
    background: var(--minicart-background-color);
  `}

  ${({ disabled }) => disabled && css`
    opacity: 0.5;
    pointer-events: none;
  `}
`

export const CheckoutButtons = styled.div`
  display: flex;
  align-items: center;

  padding: 0 var(--minicart-padding);

  gap: var(--minicart-padding);

  margin-top: 0.8em;

  span {
    width: 100%;
  }
`

export const CheckoutTotals = styled.div`
  padding: 0 var(--minicart-padding);
`

MiniCart.Head = Head
MiniCart.Title = Title
MiniCart.Lines = Lines
MiniCart.Summary = Summary
MiniCart.Detail = Detail
MiniCart.Amount = Amount
MiniCart.Close = Close
MiniCart.Cleanstate = Cleanstate
MiniCart.PoweredBy = PoweredBy
MiniCart.CheckoutButtons = CheckoutButtons
MiniCart.CheckoutTotals = CheckoutTotals
MiniCart.Button = Button
MiniCart.Notice = Notice

export default MiniCart
